export const ACCORDION_TEMPLATE = {
    parentId: null,
    accordionId: null,
    open: false
};

const state = {
    accordionParents: [],
    accordionChildren: []
}

const getters = {
    isOpen: state => (parent, child) => {
        if(!state.accordionChildren.length) {
            return false;
        }
        let accordion = state.accordionChildren.find(childAccordion => childAccordion.id === child);

        if(!accordion) {
            return false;
        }

       return accordion.open;
    },
    parent: state => (parentId) => {
        if(!state.accordionParents) {
            return false
        }

        return state.accordionParents.find(parentAccordion => parentAccordion.id === parentId)
    }
};

const actions = {

};
// mutations
const mutations = {
    registerAccordion(state, data) {
        state.accordionParents.push(data);
    },
    registerAccordionChildren(state, data) {
        state.accordionChildren.push(data)
    },
    openAccordion(state, data) {
        let foundChild = state.accordionChildren.find(child => child.id === data.id);
        let index = state.accordionChildren.indexOf(foundChild);

        state.accordionChildren.splice(index, 1,{...foundChild, open: !foundChild.open});
    },
    closeAllChildren(state, data) {
        state.accordionChildren = state.accordionChildren.map(child => {
            if(child.parentId === data.id) {
                return false
            }
            return child;
        });
    },
    closeAllSiblings(state, data) {
        state.accordionChildren = state.accordionChildren.map(child => {
            if(child.parentId === data.parentId) {
                child.open = false;
            }

            return child;
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}